import {addEducationReport, updateEducationReport, removeEducationReport} from './educationReportActions'
import {Constants} from './educationReportConstants'
import {EducationReport} from '../../../model/enums/educationReport.model'

type Actions =
    | ReturnType<typeof addEducationReport>
    | ReturnType<typeof updateEducationReport>
    | ReturnType<typeof removeEducationReport>

export function educationReportReducer(
	state: EducationReport[] = [],
	action: Actions
) {
	switch(action.type) {
	case Constants.ADD_EDUCATION_REPORT:
		return [...state, action.payload]
	case Constants.UPDATE_EDUCATION_REPORT:
		return state.map(((educationReport: EducationReport) => {
			if (educationReport.education_report_id !== action.payload.education_report_id) {
				// This isn't the item we care about - keep it as-is
				return educationReport
			}
			return {
				...educationReport,
				...action.payload
			}
		}))
	case Constants.REMOVE_EDUCATION_REPORT:
		return state.filter((educationReport: EducationReport) =>
			educationReport?.education_report_id !== action.payload)
	default:
		return state
	}

}

